import React from "react";
import Countdown from "react-countdown";
import { decrypt } from "../services/encryptionDecryptionService";

export default function Timer({ data, setOtpSent }) {
  const otpData = data.data;

  let retryCount = localStorage.getItem('retryCount') ? parseInt(localStorage.getItem('retryCount')) + 1 : 0;
  localStorage.setItem('retryCount', retryCount);
  
  const Completionist = () => <span>You are good to go!</span>;

  const renderer = ({ hours, minutes, seconds, completed }) => {
    // if (retryCount - 2 > otpData.retryCount) {
    //   return (
    //     <span style={{
    //       color: "white"
    //     }}>Limit crossed to send OTP</span>
    //   )
    // }
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    if (seconds < 10) {
      seconds = "0" + seconds;
    }
    if (completed) {
      setOtpSent();
      // Render a complete state
      return <Completionist />;
    } else {
      // Render a countdown
      return (
        <span
          style={{
            color: "white"
          }}>
          {minutes}:{seconds}
        </span>
      );
    }
  };

  const time = React.useMemo(() => {
    return Date.now() + 180000;
  }, []);

  return (
    <Countdown date={time} renderer={renderer} />
  )
}